import React from 'react';
import PropTypes from 'prop-types';
import { getDirectionsUrl } from "../../../../helpers/location";
import { LinkText } from '../../index';
import './address_link.scss';

export const AddressLink = ({
    address,
    disabled = false,
    splitAddress = false, // sets whether to split street details into separate line from city, state, and zip
    iconProps, // overrides default address icon size and color
    name,
    onClick = () => { },
    street1Key = "street1",
    street2Key = "street2",
    cityKey = "city",
    stateKey = "state",
    zipKey = "zip",
}) => {

    const getAddressUrl = (address) => {
        const toAddress = (address[street1Key] ? address[street1Key] : '') +
            (address[cityKey] ? ', ' + address[cityKey] : '') +
            (address[stateKey] ? ', ' + address[stateKey] : '') +
            (address[zipKey] ? ' ' + address[zipKey] : '');
        return getDirectionsUrl(null, toAddress);
    }

    const hasAddress = (address && address[street1Key]) ? true : false;
    const hasContent = (hasAddress || name);

    const linkProps = hasAddress
        ? {
            href: getAddressUrl(address),
            onClick: onClick,
            target: "_blank"
        }
        : {
            noRoute: true, // Disable hover/cursor style and not clickable
        };

    return (
        <LinkText
            {...linkProps}
            disabled={disabled}
            decorator="mobile"
            icon="location"
            iconProps={{
                color: iconProps?.color || "$color-primary-a3",
                size: iconProps?.size || "medium"
            }}
            typographyProps={hasContent
                ? {
                    type: 'body-01',
                }
                : {
                    type: 'heading-01',
                    color: '$color-secondary-a2'
                }}
        >
            <div className="mybswh-address-link">
                {name &&
                    <div className="mybswh-address-link__name">
                        {name}
                    </div>
                }
                {hasAddress &&
                    <div className="mybswh-address-link__address">
                        <span className="mybswh-address__street">{address[street1Key]}</span>
                        {address[street2Key] && <>, <span className="mybswh-address__street2">{address[street2Key]}</span></>}
                        {address[cityKey] && <>, {splitAddress && <br />}<span className="mybswh-address__city">{address[cityKey]}</span></>}
                        {address[stateKey] && <>, <span className="mybswh-address__state">{address[stateKey]}</span></>}
                        {address[zipKey] && <> <span className="mybswh-address__zip">{address[zipKey]}</span></>}
                    </div>
                }
                {(!hasContent) &&
                    <>
                        -
                    </>
                }
            </div>
        </LinkText>
    )
}

AddressLink.propTypes = {
    address: PropTypes.object,
    disabled: PropTypes.bool,
    iconProps: PropTypes.object,
    name: PropTypes.string,
    onClick: PropTypes.func,
    street1Key: PropTypes.string,
    street2Key: PropTypes.string,
    cityKey: PropTypes.string,
    stateKey: PropTypes.string,
    zipKey: PropTypes.string,
};
